export function productTags() {
    return {};
}
